import useIsMobile from '@/hooks/useIsMobile';

export const Loading = () => {
  const { isMobile } = useIsMobile();

  return (
    <div className="col-span-12 flex h-[400px] gap-4">
      <div className="h-full w-full animate-pulse  rounded-2xl bg-gray-300 py-8"></div>
      {!isMobile && <div className="h-full w-full animate-pulse  rounded-2xl bg-gray-300 py-8"></div>}
      {!isMobile && <div className="h-full w-full animate-pulse  rounded-2xl bg-gray-300 py-8"></div>}
    </div>
  );
};
